export default {
  toasts: {
    verification_pending: 'Tu verificación aún está pendiente',
  },
};
